import React from 'react';
import styled from 'styled-components';
import { sectionMargins } from '../styles';
import { Container, Video } from './ui';

const StyledExternalVideo = styled.section`
  ${({ isBlogSingle }) =>
    isBlogSingle ? sectionMargins('30px', '50px') : sectionMargins()}
`;

const ExternalVideo = ({ video, isBlogSingle }) => (
  <StyledExternalVideo isBlogSingle={isBlogSingle}>
    <Container narrow={isBlogSingle}>
      <Video data={video} />
    </Container>
  </StyledExternalVideo>
);

export default ExternalVideo;
